export const LANDING_URL = import.meta.env.VITE_LANDING_URL || 'https://lexalert.bg'
